import React, { useEffect } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { initializeOKRCreationPanelState } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import OKRCreationPrimaryPanelV2 from 'components/RabbitOKRCreationPanel/PrimaryPanel/V2/OKRCreationPrimaryPanelV2';
import { useSelector, useDispatch } from 'react-redux';
import { kRDrawerSecondaryPanelSelector } from 'selectors/krSecondaryPanel';

import { generateKey } from 'constants/helper';

export const CreateOKRPanelContent = ({ isOpenAsParent }) => {
  const dispatch = useDispatch();

  const secondaryPanelDetailsObject = useSelector(kRDrawerSecondaryPanelSelector);

  const { details: okrInitialDetailsFromSecondaryPanelState = {} } = secondaryPanelDetailsObject;

  const {
    type: panelType,
    parentPost = {},
    timeBoundDetails,
    parentProgressType,
    parentMeasure,
    parentMeasureType,
    isSkipResetState = false,
  } = okrInitialDetailsFromSecondaryPanelState;

  const { uuid, type, text, visibilityType } = parentPost;

  /* Initialize OKRCreationPanelState */
  useEffect(() => {
    const payload = {
      timeBoundDetails,
      parentPost: {
        uuid,
        type,
        text,
        visibilityType,
      },
      type: panelType,
      uiKey: generateKey(7),
      parentProgressType,
      parentMeasure,
      parentMeasureType,
    };

    if (isSkipResetState === false && !isOpenAsParent) {
      dispatch(initializeOKRCreationPanelState(payload));
    }
  }, [
    dispatch,
    visibilityType,
    uuid,
    type,
    text,
    timeBoundDetails,
    panelType,
    parentProgressType,
    parentMeasure,
    parentMeasureType,
    okrInitialDetailsFromSecondaryPanelState,
    isOpenAsParent,
    isSkipResetState,
  ]);

  return (
    <Flex w="100%" flexDirection="column" flex={1} overflowY="auto">
      <Box flex={1}>
        <OKRCreationPrimaryPanelV2 isAlignmentDisabled isSecondaryPanel isOpenAsParent={isOpenAsParent} />
      </Box>
    </Flex>
  );
};
